import { render, staticRenderFns } from "./AppNavigation.vue?vue&type=template&id=85e52ade"
import script from "./AppNavigation.vue?vue&type=script&lang=js"
export * from "./AppNavigation.vue?vue&type=script&lang=js"
import style0 from "./AppNavigation.vue?vue&type=style&index=0&id=85e52ade&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports